import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'
import { lighten } from 'polished'

import { Text } from '../../Atoms/Typography'
import Icon from '../../Atoms/Icon'
import ValueChangeText from '../../Molecules/ValueChangeText'

import { mapNames } from '../../../lib/business-formatters'

import theme from '../../../styles/theme'

const Card = styled(View)`
  flex: 1;
`

const CardContent = styled(View)`
  border-top-left-radius: ${theme.gutterUnit}px;
  border-top-right-radius: ${theme.gutterUnit}px;
  flex: 6;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colours.lightgrey};
  border-color: ${props => props.borderColour};
  border-width: 2px;
`

const CardMetrics = styled(View)`
  border-bottom-left-radius: ${theme.gutterUnit}px;
  border-bottom-right-radius: ${theme.gutterUnit}px;
  flex: 4;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #eeeeee;
  borderLeftColor: ${props => props.borderColour};
  borderLeftWidth: 2px;
  borderRightColor: ${props => props.borderColour};
  borderRightWidth: 2px;
  borderBottomColor: ${props => props.borderColour};
  borderBottomWidth: 2px;
`

const ValueRow = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const IconContainer = styled(View)`
  padding-bottom: ${theme.gutterUnit / 2}px;
`

const configuration = {
  HOME_LOANS: {
    colour: lighten(0.1, theme.colours.orange),
    iconName: 'home'
  },
  BUSINESS_LOANS: {
    colour: lighten(0.1, theme.colours.blue),
    iconName: 'case'
  },
  DEPOSITS: {
    colour: lighten(0.1, theme.colours.magenta),
    iconName: 'pig'
  },
  CREDIT_CARDS: {
    colour: lighten(0.1, theme.colours.green),
    iconName: 'card'
  },
  WEALTH_MANAGEMENT: {
    colour: lighten(0.1, theme.colours.green),
    iconName: 'manager'
  },
  INSTITUTIONAL_BANKING: {
    colour: lighten(0.1, theme.colours.green),
    iconName: 'skyscraper'
  },
  OFFSHORE_BANK: {
    colour: lighten(0.1, theme.colours.green),
    iconName: 'bank'
  }
}
export default class ROEItem extends PureComponent {
  render () {
    const { item } = this.props
    const { colour, iconName } = configuration[item.type]
    const value = (item.roe / 100).toFixed(1)

    return (
      <Card>
        <CardContent borderColour={colour}>
          <IconContainer>
            <Icon height={34} name={iconName} colour={colour} />
          </IconContainer>
          <Text fontSize={12} medium black overrides={{ textAlign: 'center' }}>{mapNames(item.businessName).toUpperCase()}</Text>
        </CardContent>
        <CardMetrics borderColour={colour}>
          <ValueRow style={{ alignItems: 'flex-end' }}>
            <Text size='l' medium>{value}</Text>
            <Text size='s' medium overrides={{ marginBottom: 2 }}>%</Text>
          </ValueRow>
          <ValueRow>
            <ValueChangeText dp={1} size='xs' medium value={item.roeChange} isCost={false} changeUnit='%' />
          </ValueRow>
        </CardMetrics>
      </Card>
    )
  }
}
